import ChatIcon from './ChatIcon';
export default ChatIcon;
